import React from "react";
import styles from './NavToggle.scss';

export const NavToggle = (props) => {
  const { onClick, isOffcanvasOpen = false } = props;

  return (
    <div className="navbar-toggle">
      <button className="navbar-toggler" aria-label="Burger Menu" onClick = {onClick}>
        {isOffcanvasOpen ?
        (
          <svg className="stroke" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 18L18 6M6 6L18 18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          
        ) : (
          <svg className="stroke" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 6H20M4 12H20M4 18H11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          
        )}
      </button>
    </div>
  );
}